import { Component, OnInit } from "@angular/core";
import { EnvironmentConfig, WindowService } from "@rubbl-core";
import { MarketingCard } from "@rubbl-marketing";

declare var environment: EnvironmentConfig;
@Component({
  selector: "app-list-your-machines-peace",
  templateUrl: "./list-your-machines-peace.component.html",
  styleUrls: ["./list-your-machines-peace.component.scss"],
})
export class ListYourMachinesPeaceComponent implements OnInit {
  baseImagePath: string;
  marketingCards: MarketingCard[];

  constructor(public windowService: WindowService) {
    this.baseImagePath = environment.baseImagePath;
  }

  ngOnInit() {
    this.marketingCards = [
      {
        iconClass: "icon-vetted text-dark",
        title: "Vetted renter community",
        body:
          "We vet every renter by performing an extensive review of their company’s credit history to ensure that only quality, trusted renters are using your gear.",
      },
      {
        iconClass: "icon-insurance text-dark",
        title: "Extensive protection",
        body:
          "Every machine goes through multiple 50-point inspections during the rental process and is also safeguarded with Rubbl's extensive damage coverage.",
      },
      {
        iconClass: "icon-service text-dark",
        title: "Maintenance",
        body:
          "Rubbl monitors your equipment while on rent to ensure it is properly maintained every 250 hours to protect your assets while maximizing utilization and revenue.",
      },
    ];
  }
}
